module.exports = require("./asa.d.ts");